'use strict';

import $ from 'jquery';

const init = () => {
    const $html = $('html');
    $html.removeClass('loading');
    setTimeout(function () {
        $html.removeClass('no-smooth-scroll');
    }, 500);
}

export default {init}
